import GeneralFormView from 'components/GeneralFormView';
import GeneralFormFields, { DateTimeFormFieldTypes } from 'components/GeneralFormView/types';
import { FormFieldsBuilder } from 'components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  useObserver,
} from 'mobx-react';
import { RequestStatus, stores } from 'mobx-store';
import React, { useEffect } from 'react';
import * as yup from 'yup';
import { useParams } from 'react-router-dom';
import { EventFormViewModel, EventType } from '../DtO/eventFormViewModel';
import { EventDTO } from '../DtO/eventDTO';

  
  const AddEditEventScreen: React.FC= () => {
    const { eventId } = useParams<{eventId: string}>();
    useEffect(() => {
      stores.wheelFortuneStore.getWheelEventsGroups();
    }, []);
    const getEventGroupId = (ids: number [] | undefined) => {
      if(ids && ids.length && ids[0]) {
        return ids[0];
      }
      return undefined;
    };
    const {
      formFields,
    } = new FormFieldsBuilder<EventFormViewModel>()
      .addField('title', {
        fieldOptions: {
        },
        hasTranslations: true,
        title: 'Title',
        type: GeneralFormFields.INPUT_FIELD,
        validationSchema: yup.string().required()
      })
      .addField('startTime', {
        hasTranslations: true,
        title: 'Start time',
        type: GeneralFormFields.DATE_TIME_FIELD,
        fieldOptions: {
          type: DateTimeFormFieldTypes.DATE,
        },

      })
      .addField('endTime', {
        hasTranslations: true,
        title: 'End time',
        type: GeneralFormFields.DATE_TIME_FIELD,
        fieldOptions: {
          type: DateTimeFormFieldTypes.DATE,
        },
        validationSchema: yup.date().min(yup.ref("startTime")).required()
      })
      .addField('earlyComersEdge', {
        hasTranslations: true,
        fieldOptions: {
        },
        title: 'earlyComersEdge',
        type: GeneralFormFields.INPUT_FIELD,
        validationSchema: yup.number().min(1).required()
      })
      .addField('excepctedUserNumbers', {
        hasTranslations: false,
        title: 'excepctedUserNumbers',
        type: GeneralFormFields.INPUT_FIELD,
        fieldOptions: {
        },
        validationSchema: yup.number().min(1).required()
      })
      .addField('type', {
        hasTranslations: false,
        title: 'type',
        type: GeneralFormFields.SELECT_FIELD,
        initialValue: [EventType.RENEWAL],
        fieldOptions: {
          isMultiple: false,
          items: Object.values(EventType).map(et => {
            return {
              title: et,
              value: et
            }
          }),
      },
      })
      .addField('eventGroupId', {
        hasTranslations: false,
        title: 'group name',
        type: GeneralFormFields.SELECT_FIELD,
        validationSchema: yup.array().of(yup.number().required()).optional(),
        fieldOptions: {
          isMultiple: false,
          items: stores.wheelFortuneStore.eventsGroups.map(eg => {
            return {
              title: eg.eventGroupTitle,
              value: eg.id
            }
          }),
      },
      })
      .addField('isActive', {
        hasTranslations: false,
        title: 'Active',
        type: GeneralFormFields.TOGGLE_FIELD,
        fieldOptions: {
        },
      });
      

      return useObserver(() => (
        <>
          <GeneralFormView<EventDTO, EventFormViewModel>
            defaultLang="ar"
            title="Event"
            identifier="eventId"
            otherLanguages={['en']}
            formData={formFields}
            create={async (formValue) => {
              const res = await stores.wheelFortuneStore.createEvent({
                ...formValue,
                type: formValue.type[0] as EventType,
                eventGroupId: getEventGroupId(formValue.eventGroupId)
              });
              return res;
            }}
            update={async (id, formValue, language) => {
              const res = await stores.wheelFortuneStore.updateEvent(Number(id),{
                ...formValue,
                type: formValue.type[0] as EventType,
                eventGroupId: getEventGroupId(formValue.eventGroupId)
              }, language);
              return res;
            }}
            get={async (id, language) => {
              await stores.wheelFortuneStore.getWheelEventById(Number(id), language);
              return new EventFormViewModel(stores.wheelFortuneStore.event as any);
            }}
            isFetchSuccessful={stores.wheelFortuneStore.status === RequestStatus.SUCCESS}
            createOrUpdateStatus={stores.wheelFortuneStore.createAndUpdateStatus}
          />
        </>
      ));
    

  };
  
  export default AddEditEventScreen;
  